// extracted by mini-css-extract-plugin
export default {"Container":"TabsComponent_Container__OazUq","ActiveContainerItem":"TabsComponent_ActiveContainerItem__4W0-O","InActiveContainerItem":"TabsComponent_InActiveContainerItem__AiIlC"};